import React from 'react';
import PropTypes from 'prop-types';
import refresh from '../jsx/Refresh.jsx';
import SmallTwoColumnsOpeningHoursTable from
  './PresentationalComponents/SmallTwoColumnsOpeningHoursTable.jsx';
import { StoreAvailability } from '../../../storeavailability';
import { REFRESH_INTERVAL, formatOpeningHours } from './common.jsx';

const uiSettings = require('../../../utils/UISettings.js');


function ProductPageOpeningHours(props) {
  const { openingHours, country, currentDate } = props;

  const storeOpenState = new StoreAvailability({
    openHours: openingHours,
    currentDate: currentDate
  }).getOpenState().toLowerCase();

  const className = `state-${storeOpenState}`;
  const componentTranslationPrefix = 'component.mcd';
  const nationwideBankHolidays = uiSettings.get(
    'component.mcd.store_opening_hours.nationwide_bank_holidays'
  );
  const locationBasedBankHolidays = uiSettings.get(
    'component.mcd.store_opening_hours.location_based_bank_holidays'
  );

  return (
    <SmallTwoColumnsOpeningHoursTable
      openingHours={openingHours.map((currentDay) =>
        formatOpeningHours(currentDay, componentTranslationPrefix))}
      country={country}
      className={className}
      nationwideBankHolidays={nationwideBankHolidays}
      locationBasedBankHolidays={locationBasedBankHolidays}
      storeOpenState={storeOpenState}
      currentDate={currentDate}
    />

  );
}

ProductPageOpeningHours.propTypes = {
  openingHours: PropTypes.arrayOf(PropTypes.shape({
    closeMinutes: PropTypes.number,
    day: PropTypes.string,
    openMinutes: PropTypes.number,
    order: PropTypes.number
  })).isRequired,
  country: PropTypes.string.isRequired,
  currentDate: PropTypes.objectOf(Date).isRequired
};


/**
 * Component for store opening hours in stock checker on product page
 */
export default refresh(ProductPageOpeningHours, REFRESH_INTERVAL);
